// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__1sSy-","normal":"Button_normal__1imN-","primary":"Button_primary__2h3Wk","secondary":"Button_secondary__qdbvy","loading":"Button_loading__2wMkN"};